import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Comprobamos si el usuario ya ha tomado una decisión previamente
    const consent = localStorage.getItem('firststudio_cookie_consent');
    if (!consent) {
      // Si no hay decisión guardada, mostramos el banner después de un pequeño retraso
      const timer = setTimeout(() => setIsVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('firststudio_cookie_consent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('firststudio_cookie_consent', 'declined');
    setIsVisible(false);
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, y: 50, scale: 0.95 }}
          animate={{ opacity: 1, y: 0, scale: 1 }}
          exit={{ opacity: 0, y: 20, scale: 0.95 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="fixed bottom-6 left-6 right-6 md:left-auto md:right-8 z-50 md:max-w-sm"
        >
          {/* Diseño Glassmorphism premium */}
          <div className="backdrop-blur-xl bg-black/80 border border-white/10 p-6 rounded-2xl shadow-2xl flex flex-col gap-4">
            
            <div>
              <h3 className="text-white font-semibold text-lg mb-2">Privacidad y Cookies</h3>
              <p className="text-zinc-400 text-sm leading-relaxed">
                Utilizamos cookies técnicas imprescindibles para que la web funcione correctamente. Puedes aceptar su uso o rechazarlas (solo se cargarán las esenciales).
              </p>
            </div>

            <div className="flex flex-col gap-3 mt-2">
              <button
                onClick={handleAccept}
                className="w-full bg-[#e14141] hover:bg-red-600 text-white font-medium py-2.5 rounded-lg transition-colors duration-300 text-sm"
              >
                Aceptar todas
              </button>
              
              <div className="flex gap-3">
                <button
                  onClick={handleDecline}
                  className="flex-1 border border-white/20 hover:border-white/40 text-zinc-300 hover:text-white font-medium py-2 rounded-lg transition-colors duration-300 text-sm"
                >
                  Rechazar
                </button>
                <a
                  href="/politica-cookies"
                  className="flex-1 flex items-center justify-center text-zinc-500 hover:text-zinc-300 text-xs underline transition-colors"
                >
                  Ver política
                </a>
              </div>
            </div>

          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieBanner;
